import React, { useEffect, useRef } from "react";

export default function SmokeHoverSection() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let animationId;

    // =========================
    // Resize
    // =========================
    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);

      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;

      canvas.style.width = "100vw";
      canvas.style.height = "100vh";
    };

    resize();
    window.addEventListener("resize", resize);

    // =========================
    // Pointer
    // =========================
    const pointer = {
      x: 0,
      y: 0,
      px: 0,
      py: 0,
      dx: 0,
      dy: 0,
      moved: false,
    };

    // =========================
    // Particles
    // =========================
    const particles = [];

    const addParticle = (x, y, dx, dy) => {
      particles.push({
        x,
        y,
        dx,
        dy,
        life: 1,
      });

      if (particles.length > 120) particles.shift();
    };

    // =========================
    // Mouse move
    // =========================
    const onMove = (e) => {
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;

      pointer.dx = x - pointer.px;
      pointer.dy = y - pointer.py;

      pointer.px = x;
      pointer.py = y;

      pointer.x = x;
      pointer.y = y;

      pointer.moved = true;
    };

    window.addEventListener("mousemove", onMove);

    // =========================
    // DRAW LOOP
    // =========================
    const draw = () => {
      if (!ctx || !canvas) return;

      // ✅ NO BACKGROUND (clean transparent canvas)
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // add particles
      if (pointer.moved) {
        addParticle(pointer.x, pointer.y, pointer.dx, pointer.dy);
        pointer.moved = false;
      }

      for (let i = 0; i < particles.length; i++) {
        const p = particles[i];

        p.life -= 0.015;
        if (p.life <= 0) {
          particles.splice(i, 1);
          i--;
          continue;
        }

        const px = p.x * canvas.width;
        const py = p.y * canvas.height;

        const radius = Math.max(10, 120 * p.life);

        const gradient = ctx.createRadialGradient(
          px,
          py,
          0,
          px,
          py,
          radius
        );

        gradient.addColorStop(0, `rgba(0,255,255,${p.life})`);
        gradient.addColorStop(0.5, `rgba(0,150,255,${p.life * 0.5})`);
        gradient.addColorStop(1, "transparent");

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(px, py, radius, 0, Math.PI * 2);
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    draw();

    // =========================
    // Cleanup
    // =========================
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  );
}
